import { withInstall } from '@bigin/utils'

import Affix from './src/affix.vue'

export const BAffix = withInstall(Affix)
export default BAffix

export * from './src/affix'
